import { deleteRequest, getRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    updateAssignment: (id, body) => patchRequest(`/assignments/${id}`, body),
    deleteAssignment: (id) => deleteRequest(`/assignments/${id}`),
    getAssignmentBatch: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/assignments/${id}/batch?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    createAssignmentFeedback: (id, body) => postRequest(`/assignments/${id}/feedback`, body),
    getAssignmentFeedback: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/assignments/${id}/feedback?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    getAssignmentSubmissionCount: (id) => getRequest(`/assignments/${id}/submissions/count`),
    getAssignmentSubmissions: async (id, filter = null, orderBy = null, skip = null, top = 200) => {
        let accumulatedResults = [];
        const { total, results } = await getRequest(
            `/assignments/${id}/submissions?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
        accumulatedResults = [...accumulatedResults, ...results];
        while (accumulatedResults.length < total) {
            const { results } = await getRequest(
                `/assignments/${id}/submissions?$filter=${encodeURIComponent(filter)}&$orderBy=${orderBy}&$skip=${
                    accumulatedResults.length
                }&$top=${top}`
            );
            accumulatedResults = [...accumulatedResults, ...results];
        }
        return accumulatedResults;
    },
    deleteAssignmentBatch: (id) => deleteRequest(`/assignments/${id}/batch`),
    deleteAssignmentSubmissions: (id) => deleteRequest(`/assignments/${id}/submissions`),
};

export default services;
